import { Selector } from 'reselect'

import {
  SnackbarState,
} from '../../types/store'

import {
  RootState,
} from '../../types/store'

export const data: Selector<RootState, SnackbarState> = state => state.snackbar

export default {
  data,
}
